import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { useEffect, useState } from "react";
import PText from "../../components/pos/PText";
import { Grid, IconButton, InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
export default function MValueCapture(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  const mobileContent = (
    <div style={{ marginTop: 10 }}>
      <MText
        label={props.textLabel}
        autoFocus={true}
        value={value}
        type={props.type ? props.type : "text"}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      ></MText>
    </div>
  );

  const desktopContent = (
    <Grid container>
      <Grid item xs={12} sx={{ marginTop: "10px" }}>
        <PText
          label={translate("Note")}
          value={value}
          onChange={(e) => {
            console.log(e.target.value);
            setValue(e.target.value);
          }}
          autoFocus={true}
          multiline={true}
          maxRows={4}
          rows={4}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ color: "red" }}
                  onClick={() => {
                    setValue("");
                  }}
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        ></PText>
      </Grid>
    </Grid>
  );

  return (
    <MScreen
      maxWidth="xs"
      title={props.textLabel}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setShowValueCapture(false)}
      rightAction={translate("OK")}
      onRightAction={() => {
        if (props.mode === "value_capture_note") {
          props.onOkay(value);
          props.setShowValueCapture(false);
        }
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      dialogMode={true}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      content={
        props.context.appMode === "desktop-pos" ? desktopContent : mobileContent
      }
    ></MScreen>
  );
}
